import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { array, object } from 'prop-types';
import { get, isEmpty, uniqBy } from 'lodash';

import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

import { CSVLink } from 'react-csv';

import ActionBar from '../../components/ActionBar';
import HealthMonitorTable from './HealthMonitorTable';

import * as HomeActions from '../../actions/homeActions';

import classes from './HealthMonitorView.module.css';


const HealthMonitorView = ({
    healthChecks,
    node,
    onToggleCreateServiceRequestModal
}) => {
    const headers = [
        { key: 'name', label: 'Name' },
        { key: 'snapshotRoute', label: 'Target' },
        { key: 'status', label: 'Status' },
        { key: 'priority', label: 'Priority' },
        { key: 'issueTypes', label: 'Issue Types' }
    ];

    const [searchTerm, setSearchTerm] = useState('');
    const [data, setData] = useState([]);

    useEffect(() => {
        setData(healthChecks);
    }, [healthChecks]);

    function handleSearch(event) {
        const input = get(event, 'target.value', '');
        setSearchTerm(input);

        let updatedList = healthChecks;
        let nameResults, targetResults;

        if (!isEmpty(input)) {
            const updatedInput = input.toLowerCase();

            nameResults = updatedList.filter(item => item.name.toLowerCase().includes(updatedInput));
            targetResults = updatedList.filter(item => item.snapshotRoute.toLowerCase().includes(updatedInput));

            updatedList = uniqBy([...nameResults, ...targetResults], 'snapshotRoute');
        }

        setData(updatedList);
    }

    return (
        <div className={classes.HealthMonitorView}>
            <div className={classes.actionBar}>
                <TextField
                    onChange={handleSearch}
                    value={searchTerm}
                    variant="outlined"
                    className={classes.search}
                    placeholder="Search"
                    type="search"
                    InputProps={{
                        startAdornment: <SearchIcon color="disabled" />
                    }}
                />
                <ActionBar>
                    <CSVLink
                        className={classes.exportLink}
                        data={data}
                        filename={`${node.name}-Health-Monitor.csv`}
                        headers={headers}
                    >
                        <img src="assets/images/exportIconFlat.svg" alt="" />
                        Export
                    </CSVLink>
                </ActionBar>
            </div>
            <HealthMonitorTable rows={data} onToggleCreateServiceRequestModal={onToggleCreateServiceRequestModal} />
        </div>

    );
};

HealthMonitorView.defaultProps = {
    healthChecks: [],
    node:         {}
};

HealthMonitorView.propTypes = {
    healthChecks: array.isRequired,
    node:         object.isRequired
};

const mapStateToProps = state => {
    return {
        healthChecks: state.home.healthChecks
    };
};

const mapDispatchToProps = {
    ...HomeActions
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthMonitorView);
